import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Grid, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';

const ChatListEmpty = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid
      className={classes.root}
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <CustomizedTypography
        className={classes.text}
        variant={!matches ? 'h4' : 'body1'}
        color="textSecondary"
        align="center"
        gutterBottoms={32}
      >
        아직 받은 채팅이 없습니다
      </CustomizedTypography>
    </Grid>
  );
};

export default ChatListEmpty;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    top: 61,
    height: 'calc(100% - 61px)',
    backgroundColor: colorSet.gray000,
    position: 'relative',
    zIndex: 1100,
    [theme.breakpoints.down('md')]: {
      height: 'calc(100% - 124px)',
      top: 68
    }
  },
  text: {
    color: '#CED4DA'
  }
}));
